import './App.css';
import './LandingPage.css';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';

const ButterflyMenu = ({ signOut }) => {
  const navigate = useNavigate();

  const navigateTo = (path) => {
    navigate(path);
  };

  const ActionButton = ({ onClick, title, tooltip }) => (
    <button
      onClick={onClick}
      title={tooltip}
      style={{
        padding: '12px 16px',
        background: 'rgba(59, 130, 246, 0.1)',
        border: '1px solid rgba(59, 130, 246, 0.3)',
        borderRadius: '8px',
        color: '#3b82f6',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s',
        textAlign: 'center',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)';
      }}
    >
      {title}
    </button>
  );

  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
            Butterfly Strategy
          </h1>
        </div>

        {/* Butterfly Options Section */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">🦋 Custom Butterfly</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <ActionButton
                onClick={() => navigateTo('/generateButterflyOptionsLegs')}
                title="Generate Options Legs"
                tooltip="Create butterfly options with adjustable parameters"
              />
            </div>
          </div>
        </div>

        {/* ETFs and Indices Side by Side */}
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          {/* ETFs Section */}
          <div className="landing-panel" style={{ flex: '1', minWidth: '300px' }}>
            <div className="landing-panel-header">
              <h2 className="landing-panel-title">📊 ETFs</h2>
            </div>
            <div className="landing-panel-content">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <ActionButton
                  onClick={() => navigateTo('/generateButterflyOptionsLegsSpy')}
                  title="SPY Butterfly"
                  tooltip="Pre-configured SPY butterfly"
                />
                <ActionButton
                  onClick={() => navigateTo('/generateButterflyOptionsLegsQqq')}
                  title="QQQ Butterfly"
                  tooltip="Pre-configured QQQ butterfly"
                />
                <ActionButton
                  onClick={() => navigateTo('/generateButterflyOptionsLegsIwm')}
                  title="IWM Butterfly"
                  tooltip="Pre-configured IWM butterfly"
                />
              </div>
            </div>
          </div>

          {/* Indices Section */}
          <div className="landing-panel" style={{ flex: '1', minWidth: '300px' }}>
            <div className="landing-panel-header">
              <h2 className="landing-panel-title">📈 Indices</h2>
            </div>
            <div className="landing-panel-content">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <ActionButton
                  onClick={() => navigateTo('/generateButterflyOptionsLegsSpx')}
                  title="S&P 500 (SPX) Butterfly"
                  tooltip="Pre-configured S&P 500 (SPX) butterfly"
                />
                <ActionButton
                  onClick={() => navigateTo('/generateButterflyOptionsLegsNdx')}
                  title="Nasdaq 100 (NDX) Butterfly"
                  tooltip="Pre-configured Nasdaq 100 (NDX) butterfly"
                />
                <ActionButton
                  onClick={() => navigateTo('/generateButterflyOptionsLegsRut')}
                  title="Russell 2000 (RUT) Butterfly"
                  tooltip="Pre-configured Russell 2000 (RUT) butterfly"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
};

export default ButterflyMenu;